module.exports = __webpack_public_path__ + "img/political_compass.ac13d7da.png";